import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";

@Injectable()
export class Configuration {
  public ApiUrl = "";

  /* Reset password end points*/
  public readonly getResetPasswordVerifyTokenUrl ="";
  public readonly getSendOTPUrl = "";
  public readonly getVerifyOTPUrl = "";
  public readonly getResetPasswordUrl = "";
}


// we have habdling two application here one for normal client and one for bass client 
// The flow is same but the endpoints are diffrent because of that this resolver has written
// It will check 
@Injectable({ providedIn: "root" })
export class AppRouteResolver implements Resolve<any> {
  configuration: any;
  constructor(configuration: Configuration) {
    this.configuration = configuration;
  }
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    if (state.url.includes("baas-sca")) {
      sessionStorage.setItem("APP_SOURCE", 'bass-sca');
      this.configuration.ApiUrl = "";
      this.configuration.getResetPasswordVerifyTokenUrl = "/ob-agg-sca/user/password/recovery/details";
      this.configuration.getSendOTPUrl = "/ob-agg-sca/user/initiate/authorization";
      this.configuration.getVerifyOTPUrl = "/ob-agg-sca/user/verify/authorization";
      this.configuration.getResetPasswordUrl = "/ob-agg-sca/user/password/recovery";
    } else {
      sessionStorage.setItem("APP_SOURCE", 'online-banking');
      this.configuration.ApiUrl = "/ib-security/";
      this.configuration.getResetPasswordVerifyTokenUrl = "secure/banking/utility/ib/verifyToken";
      this.configuration.getSendOTPUrl = "secure/banking/agg/otp/create";
      this.configuration.getVerifyOTPUrl = "secure/banking/agg/otp/verify";
      this.configuration.getResetPasswordUrl = "secure/banking/utility/ib/resetPassword";
    }
    return this.configuration;
  }
}
